import {
  Text,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Image,
  InputGroup,
  FormControl,
  Input,
  Switch,
  useToast,
  FormLabel,
  Select,
  Radio,
  Box,
} from "@chakra-ui/react";
import { ModalAnimal } from "../../components/ModalCadEdiAnimal";
import { Container, StyledImage } from "./styles";
import { getUser } from "../../context/token";
import { useEffect, useState } from "react";
import { AxiosError } from "axios";
import { api } from "../../Api/ApiService";
import Alert from "sweetalert2";
import dayjs from "dayjs";
import { useForm } from "react-hook-form";
import { convertToBase64 } from "../../utils/bse64Foto";
import { ModalInforComp } from "../ModalInforcomplementares";
import { NotePencil } from "@phosphor-icons/react";

interface IInputsAdocao {
  animal_id: string;
  tutor_nome: string;
  tutor_cpf: string;
  documento: File | any;
}

type AnimalProps = {
  animal_id: string;
  tipo_animal: string;
  foto: Buffer;
  nome: string;
  raca: string;
  sexo: string;
  descricao?: string;
  disponibilidade: boolean;
  castrado: boolean;
};

interface InforEvento {
  id_evento: string;
  nome_evento: string;
  local_evento: string;
  data: string;
  horas: [];
}

interface IInputsEvento {
  data: string;
  hora: string;
  animal_id: string;
  evento_id: string;
  email_tutor: string;
  aceite: string;
}

export const Animal = ({
  animal_id,
  tipo_animal,
  foto,
  nome,
  raca,
  descricao,
  sexo,
  disponibilidade,
  castrado,
}: AnimalProps) => {
  const { role } = getUser();
  const base64teste = convertToBase64(foto);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isModal, setIsModal] = useState(false);
  const [isModalEd, setIsModalEd] = useState(false);
  const toast = useToast();
  const { email } = getUser();
  const [eventos, setEventos] = useState<InforEvento[]>([]);
  const [horariosDiponiveis, setHorariosDiponiveis] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [id_evento, setId_evento] = useState("");
  const [tutorID, setTutorID] = useState("");
  const [isModalUp, setIsModalUp] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset: resetForm,
  } = useForm<IInputsEvento>();

  const {
    register: registerAdocao,
    handleSubmit: handleSubmitAdocao,
    formState: { errors: errorsAdocao },
  } = useForm<IInputsAdocao>();

  async function onSubmitDisponibilidade(status: boolean) {
    try {
      Alert.fire({
        toast: true,
        icon: "warning",
        text: "Tem certeza que deseja alterar a disponibilidade do animal?",
        showCancelButton: true,
        cancelButtonText: "Não",
        cancelButtonColor: "red",
        confirmButtonText: "Sim",
        confirmButtonColor: "#044549",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const res = await api.patch(
            `/animais/${animal_id}/${status}?token=${process.env.REACT_APP_TOKEN_API}`
          );

          Alert.fire({
            toast: true,
            icon: "success",
            text: res.data.message,
            confirmButtonText: "OK",
            confirmButtonColor: "#3f3d56",
          }).then(() => {
            window.location.reload();
          });

          onClose();
        } else {
          onClose();
        }
      });
    } catch (error: AxiosError | any) {
      console.log(error);
      toast({
        title: "Erro",
        description: error.response.data,
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    }
  }

  async function PreAdotar(id_animal: string, email: string) {
    try {
      const result = await api.get(
        `/pre_adocoes/${email}/${id_animal}/?token=${process.env.REACT_APP_TOKEN_API}`
      );

      if (result.data.permission) {
        setIsModal(true);
        setEventos(result.data.horarios_disponiveis);
      } else if (result.data.codResponse == 5) {
        const tutor = await api.get(
          `/tutor?token=${process.env.REACT_APP_TOKEN_API}`,
          {
            params: {
              email: email,
            },
          }
        );
        setTutorID(tutor.data.data.tutor_id);
        setIsModalUp(true);
        handleOpenModal();

        toast({
          title: "Você ainda não complementou suas informações",
          description:
            "É necessário complementar as informações antes de fazer a pré-adoção",
          status: "warning",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      } else {
        onClose();
        Alert.fire({
          toast: true,
          icon: "warning",
          text: `${result.data.message} Para mais informaçãoes entre em contato conosco pelo WhastApp`,
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> (88) 8826-2563',
          confirmButtonColor: "#044549",
          showCancelButton: true,
          cancelButtonText: "Fechar",
          cancelButtonColor: "#c03333",
        }).then((result) => {
          if (result.isConfirmed) {
            window.open("https://api.whatsapp.com/send?phone=558888262563");
          }
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleDateChange = (event: any) => {
    const selectedDate = event.target.value;
    setSelectedDate(selectedDate);

    const eventForSelectedDate = eventos.find(
      (event) => event.data === selectedDate
    );

    if (eventForSelectedDate != null) {
      setHorariosDiponiveis(eventForSelectedDate.horas);
      setId_evento(eventForSelectedDate.id_evento);
    }
  };

  async function onSubmit(data: IInputsEvento) {
    try {
      const result = await api.post(
        `/agendamentos?token=${process.env.REACT_APP_TOKEN_API}`,
        {
          data: data.data,
          hora: data.hora,
          animal_id: animal_id,
          evento_id: id_evento,
          email_tutor: email,
        }
      );

      Alert.fire({
        toast: true,
        icon: "success",
        text: `${result.data.message}. Verifique a seu email para mais informações.`,
        confirmButtonText: "OK",
        confirmButtonColor: "#3f3d56",
      }).then(() => {
        window.location.reload();
      });
    } catch (error: AxiosError | any) {
      toast({
        title: "Erro",
        description: error.response.data,
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    }
  }

  async function onSubmitAdocao(data: IInputsAdocao) {
    try {
      Alert.fire({
        toast: true,
        icon: "warning",
        text: "Tem certeza que deseja registrar a adoção do animal? Isso impactarar na disponibilidade",
        showCancelButton: true,
        cancelButtonText: "Não",
        cancelButtonColor: "red",
        confirmButtonText: "Sim",
        confirmButtonColor: "#044549",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const dados = new FormData();
          dados.append("documento", data.documento.item(0));
          dados.append("tutor_nome", data.tutor_nome);
          dados.append("tutor_cpf", data.tutor_cpf);
          dados.append("animal_id", animal_id);

          const adocao_add = await api.post(
            `/adocoes?token=${process.env.REACT_APP_TOKEN_API}`,
            dados
          );

          const res = await api.patch(
            `/animais/${animal_id}/${false}?token=${
              process.env.REACT_APP_TOKEN_API
            }`
          );

          Alert.fire({
            toast: true,
            icon: "success",
            text: adocao_add.data.message,
            confirmButtonText: "OK",
            confirmButtonColor: "#3f3d56",
          }).then(() => {
            window.location.reload();
          });

          onClose();
        }
      });
    } catch (error: AxiosError | any) {
      console.log(error);
      toast({
        title: "Erro",
        description: error.response.data,
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    }
  }

  const handleOpenModal = () => {
    setIsModal(true);
  };

  const handleCloseModal = () => {
    setIsModal(false);
  };

  const handleCloseModalEd = () => {
    setIsModalEd(false);
  };

  return (
    <Container>
      <img className="img" src={`data:image/jpeg;base64,${base64teste}`}></img>
      <div className="infor">
        <Text fontWeight={500}>Nome: </Text>
        <Text>{nome}</Text>
        <Text fontWeight={500}>Raça: </Text>
        <Text>{raca}</Text>
      </div>

      <div className="acoes">
        {role === "admin" ? (
          <div className="editar">
            <button onClick={() => setIsModalEd(true)}>
              <NotePencil className="btn-editar" size={30} color="#147706" />
            </button>
            <ModalAnimal
              modo="editar"
              onClose={handleCloseModalEd}
              isOpen={isModalEd}
              animal_id={animal_id}
              nome={nome}
              raca={raca}
              tipo_animal={tipo_animal}
              sexoA={sexo}
              descricao={descricao}
              disponibilidade={disponibilidade}
              castradoA={castrado}
              foto={foto}
            />
          </div>
        ) : (
          <></>
        )}
        <div className="btn-vermais">
          <Button className="btn" onClick={onOpen}>
            Ver mais
          </Button>
        </div>
      </div>

      <Modal onClose={onClose} size={"xl"} isOpen={isOpen}>
        <ModalOverlay />
        <ModalContent>
          <ModalBody>
            <StyledImage src={`data:image/jpeg;base64,${base64teste}`} />

            <FormControl
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <FormControl display={"flex"} flexDir={"row"}>
                <InputGroup gap={5} mt={3}>
                  <Text fontWeight={500}>Nome: </Text>
                  <Text>{nome}</Text>
                </InputGroup>
                <InputGroup gap={5} mt={3}>
                  <Text fontWeight={500}>Tipo: </Text>
                  <Text>{tipo_animal}</Text>
                </InputGroup>
              </FormControl>
            </FormControl>
            <FormControl display={"flex"} flexDir={"row"}>
              <InputGroup gap={8} mt={3}>
                <Text fontWeight={500}>Sexo: </Text>
                <Text>{sexo}</Text>
              </InputGroup>
              <InputGroup gap={8} mt={3}>
                <Text fontWeight={500}>Raça: </Text>
                <Text>{raca}</Text>
              </InputGroup>
            </FormControl>
            <InputGroup gap={3} mt={3}>
              <Text fontWeight={500}>Castrado: </Text>
              <Text>{castrado === false ? "Não" : "Sim"}</Text>
            </InputGroup>
            {descricao && descricao != "undefined" ? (
              <InputGroup gap={1} mt={3} display={"flex"} flexDir={"column"}>
                <Text fontWeight={500}>Descrição: </Text>
                <Text>{descricao}</Text>
              </InputGroup>
            ) : (
              <></>
            )}

            {role == "admin" ? (
              <>
                <InputGroup gap={8} mt={3} alignItems={"center"}>
                  <Text fontWeight={500}>Disponível para adoção? </Text>
                  <Switch
                    colorScheme="teal"
                    size={"md"}
                    defaultChecked={disponibilidade}
                    isRequired
                    onChange={(e) => {
                      onSubmitDisponibilidade(e.target.checked);
                    }}
                  />
                </InputGroup>
                {disponibilidade ? (
                  <form
                    encType="multipart/form-data"
                    onSubmit={handleSubmitAdocao(onSubmitAdocao)}
                  >
                    <Box
                      boxShadow={
                        "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px"
                      }
                      borderRadius={"20px"}
                      padding={5}
                      marginTop={10}
                    >
                      <Text
                        fontWeight={"bold"}
                        fontSize={18}
                        color={"#3f3d56"}
                        display={"flex"}
                        justifyContent={"center"}
                      >
                        REGISTRAR ADOÇÃO
                      </Text>
                      <InputGroup gap={8} mt={3} alignItems={"center"}>
                        <Text fontWeight={500} w={"40%"}>
                          Nome do tutor:
                        </Text>
                        <Input
                          fontSize={15}
                          variant={"filled"}
                          border={"1px solid #B0BEC5"}
                          borderRadius={5}
                          size={"sm"}
                          {...registerAdocao("tutor_nome", {
                            required: "Campo obrigatório",
                          })}
                        />
                      </InputGroup>
                      <InputGroup gap={8} mt={3} alignItems={"center"}>
                        <Text fontWeight={500} w={"40%"}>
                          CPF do tutor:
                        </Text>
                        <Input
                          fontSize={15}
                          variant={"filled"}
                          border={"1px solid #B0BEC5"}
                          borderRadius={5}
                          size={"sm"}
                          {...registerAdocao("tutor_cpf", {
                            required: "Campo obrigatório",
                          })}
                        />
                      </InputGroup>
                      <InputGroup marginTop={3}>
                        <Text fontWeight={500} w={"40%"}>
                          Documento de Adoção:
                        </Text>
                        <Input
                          type={"file"}
                          variant={"outline"}
                          accept={".pdf"}
                          marginLeft={3}
                          {...registerAdocao("documento", {
                            required: "Campo obrigatório",
                          })}
                        />
                      </InputGroup>
                      <InputGroup
                        marginTop={4}
                        display={"flex"}
                        justifyContent={"end"}
                      >
                        <Button
                          type="submit"
                          w={40}
                          h={8}
                          border={"1px solid #044549"}
                          color={"#044549"}
                          backgroundColor={"white"}
                          fontWeight={"medium"}
                        >
                          Salvar
                        </Button>
                      </InputGroup>
                    </Box>
                  </form>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <></>
            )}
          </ModalBody>
          <ModalFooter mt={15}>
            {role == "admin" ? (
              <Button
                w={40}
                h={8}
                border={"1px solid #c03333"}
                color={"#c03333"}
                fontWeight={"medium"}
                marginRight={"5"}
                backgroundColor={"white"}
                onClick={onClose}
              >
                Fechar
              </Button>
            ) : (
              <InputGroup gap={8} display={"contents"}>
                <Button
                  w={40}
                  h={8}
                  border={"1px solid #c03333"}
                  color={"#c03333"}
                  fontWeight={"medium"}
                  marginRight={"5"}
                  backgroundColor={"white"}
                  onClick={onClose}
                >
                  Fechar
                </Button>

                <Button
                  type="submit"
                  w={40}
                  h={8}
                  border={"1px solid #044549"}
                  color={"#044549"}
                  backgroundColor={"white"}
                  fontWeight={"medium"}
                  onClick={() => PreAdotar(animal_id, email)}
                >
                  Pré-adotar
                </Button>
              </InputGroup>
            )}
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal onClose={onClose} size={"xl"} isOpen={isModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign={"center"} fontSize={25} color={"#2F2E41"}>
            Escolha uma data para a entrevista
          </ModalHeader>
          <form onSubmit={handleSubmit(onSubmit)}>
            <ModalBody>
              <InputGroup pr={10} pl={10} alignItems={"center"}>
                <FormLabel w={200}>Escolha o dia e local:</FormLabel>
                <Select
                  placeholder="Selecione uma opção"
                  size="sm"
                  {...register("data", {
                    required: "Campo obrigatório",
                  })}
                  isRequired
                  onChange={handleDateChange}
                >
                  {eventos.map((item, idx) => {
                    return (
                      <option key={idx} value={item.data}>
                        {`${dayjs(item.data).format("DD/MM/YYYY")} - ${
                          item.local_evento
                        }`}
                      </option>
                    );
                  })}
                </Select>
              </InputGroup>
              <InputGroup pr={10} pl={10} pt={5} alignItems={"center"}>
                <FormLabel w={200}>Escolha o horário:</FormLabel>
                <Select
                  placeholder="Selecione uma opção"
                  size="sm"
                  {...register("hora", {
                    required: "Campo obrigatório",
                  })}
                  isRequired
                >
                  {horariosDiponiveis.map((item, idx) => {
                    return (
                      <option key={idx} value={item}>
                        {item}
                      </option>
                    );
                  })}
                  {errors.hora?.message && (
                    <span className="label-erro">{errors.hora.message}</span>
                  )}
                </Select>
              </InputGroup>
              <FormControl pt={5} pr={10} pl={10} fontSize={13}>
                <Text>
                  Art. 32. Praticar ato de abuso, maus-tratos, ferir ou mutilar
                  animais silvestres, domésticos ou domesticados, nativos ou
                  exóticos:
                </Text>
                <Text>Pena - detenção, de três meses a um ano, e multa.</Text>
                <Text>
                  § 1º Incorre nas mesmas penas quem realiza experiência
                  dolorosa ou cruel em animal vivo, ainda que para fins
                  didáticos ou científicos, quando existirem recursos
                  alternativos.
                </Text>
                <Text>
                  § 1º-A Quando se tratar de cão ou gato, a pena para as
                  condutas descritas no caput deste artigo será de reclusão, de
                  2 (dois) a 5 (cinco) anos, multa e proibição da guarda.
                </Text>
                <Text>
                  § 2º A pena é aumentada de um sexto a um terço, se ocorre
                  morte do animal.
                </Text>
              </FormControl>
              <FormControl pt={5} pl={10}>
                <Radio
                  value={"1"}
                  {...register("aceite", {
                    required: "Campo obrigatório",
                  })}
                >
                  Estou ciente
                </Radio>
              </FormControl>
              {errors.aceite?.message && (
                <Text color={"red"} ml={10}>
                  {errors.aceite.message}
                </Text>
              )}
            </ModalBody>
            <ModalFooter mt={15}>
              <InputGroup gap={8} display={"contents"}>
                <Button
                  w={40}
                  h={8}
                  border={"1px solid #c03333"}
                  color={"#c03333"}
                  fontWeight={"medium"}
                  marginRight={"5"}
                  backgroundColor={"white"}
                  onClick={() => {
                    setIsModal(false);
                    resetForm();
                  }}
                >
                  Fechar
                </Button>

                <Button
                  type="submit"
                  w={40}
                  h={8}
                  border={"1px solid #044549"}
                  color={"#044549"}
                  backgroundColor={"white"}
                  fontWeight={"medium"}
                >
                  Salvar
                </Button>
              </InputGroup>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
      {isModalUp ? (
        <>
          <ModalInforComp
            tutor_id={tutorID}
            onClose={handleCloseModal}
            isOpen={isModal}
          />
        </>
      ) : (
        <></>
      )}
    </Container>
  );
};
